import { render, staticRenderFns } from "./ChangeLocation.vue?vue&type=template&id=1001b455&scoped=true&"
import script from "./ChangeLocation.vue?vue&type=script&lang=js&"
export * from "./ChangeLocation.vue?vue&type=script&lang=js&"
import style0 from "./ChangeLocation.vue?vue&type=style&index=0&id=1001b455&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1001b455",
  null
  
)

export default component.exports